// This file is auto generated. DO NOT TOUCH!

import {UpdateUserProfileData} from "@/api";
import {UpdateExtensionProfileDataFieldDesc} from "./types";

import {FeatureRestriction} from "@/api";

type DescType = {[s in keyof UpdateUserProfileData]: UpdateExtensionProfileDataFieldDesc};

export const updateExtensionProfileDataFieldDescriptor: DescType = {
    settings: {
        businessOnly: false,
    },
    anonymousCallRejection: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRejections,
    },
    callForwardBusy: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardBusyNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardFault: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardFaultNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardNoanswer: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardNoanswerNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardNoanswer_: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardNoanswerTimeout: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardUnavailable: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardUnavailableNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardUnconditional: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callForwardUnconditionalNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    callingNamePresentation: {
        businessOnly: false,
    },
    callingNumberPresentationRestriction: {
        businessOnly: false,
        restriction: FeatureRestriction.NumberPresentation,
    },
    connectedNumberPresentationRestriction: {
        businessOnly: false,
        restriction: FeatureRestriction.NumberPresentation,
    },
    doNotDisturb: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRejections,
    },
    locked: {
        businessOnly: false,
        restriction: FeatureRestriction.Locking,
    },
    name: {
        businessOnly: false,
    },
    parallelRinging: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    parallelRingingNumber: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRoutings,
    },
    rejectDivertedCalls: {
        businessOnly: false,
        restriction: FeatureRestriction.CallRejections,
    },
    secretaryMode: {
        businessOnly: false,
    },
    stickyProfile: {
        businessOnly: false,
    },
};
